import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import ListView from "../../common/list";
import type { ColumnDefinition } from "@frui.ts/dataviews";
import GateWaysFilters from "./kiosksFilters";
import KiosksViewModel from "viewModels/administration/kiosks/kiosksViewModel";
import type KioskResponse from "entities/kioskResponse";
import KioskDisplayStatus from "entities/kioskDisplayStatus";
import KioskPurchaseStatus from "entities/kioskPurchaseStatus";

const KiosksView: ViewComponent<KiosksViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<KioskResponse>[] = [
    {
      title: vm.translateAttribute("kioskIdent"),
      property: "kioskIdent",
    },
    {
      title: vm.translateAttribute("alias"),
      property: "alias",
    },
    {
      title: vm.translateAttribute("name"),
      property: "name",
    },
    {
      title: vm.translateAttribute("locationName"),
      property: "locationName",
    },
    {
      title: vm.translateAttribute("terminalId"),
      property: "terminalId",
    },
    {
      title: vm.translateAttribute("purchaseStatus"),
      property: "purchaseStatus",
      valueFormatter: props =>
        props.value === KioskPurchaseStatus.Allowed ? vm.translateGeneral("boolean.true") : vm.translateGeneral("boolean.false"),
    },
    {
      title: vm.translateAttribute("displayStatus"),
      property: "displayStatus",
      valueFormatter: props =>
        props.value === KioskDisplayStatus.Visible ? vm.translateGeneral("boolean.true") : vm.translateGeneral("boolean.false"),
    },
  ];
  return <ListView vm={vm} columns={columns} aboveTable={<GateWaysFilters vm={vm} />} />;
});

registerView(KiosksView, KiosksViewModel);
